import React, {memo} from 'react';
import {useNavigate} from 'react-router-dom';
import FavoriteButton from './FavoriteButton';
import PropTypes from 'prop-types';
import {Tooltip} from "antd";

const DashboardCard = ({dashboard, onToggleFavorite}) => {
    const navigate = useNavigate();

    return (
        <div
            className="group relative bg-white dark:bg-gray-800 p-4 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-lg hover:border-blue-500 dark:hover:border-blue-500 transition-all duration-300 flex flex-col cursor-pointer overflow-hidden"
            onClick={() => navigate(dashboard.path)}
        >
            {dashboard.is_homologado === 0 && (
                <div className="absolute top-2 -right-11 bg-amber-500 text-white text-xs font-bold px-10 py-1 transform rotate-45 z-10 shadow-sm">
                    HOMOLOGAÇÃO
                </div>
            )}
            <div className="flex justify-between items-start">
                <h4 className="font-bold text-gray-900 dark:text-gray-100 pr-8 truncate group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                    {dashboard.label}
                </h4>
                <FavoriteButton
                    dashboardId={dashboard.id}
                    isFavorite={dashboard.is_favorito}
                    onToggle={onToggleFavorite}
                />
            </div>
            <Tooltip title={dashboard.description} placement="top">
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 line-clamp-2 flex-grow"
                   aria-label={dashboard.description}>
                    {dashboard.description}
                </p>
            </Tooltip>
            <span
                className="text-sm font-bold text-blue-600 dark:text-blue-400 mt-4 self-start opacity-0 group-hover:opacity-100 transition-opacity">
                Acessar →
            </span>
        </div>
    );
};

DashboardCard.propTypes = {
    dashboard: PropTypes.shape({
        id: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        description: PropTypes.string,
        path: PropTypes.string.isRequired,
        is_homologado: PropTypes.number,
        is_favorito: PropTypes.bool
    }).isRequired,
    onToggleFavorite: PropTypes.func.isRequired
};

export default memo(DashboardCard);
